import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import { parseFormFields } from './donate-form-utils';
import DonateFormFields from './donate-form-fields/DonateFormFields';
import styles from './DonateFormApp.scss';
import DonateFormActions from './donate-form-actions/DonateFormActions';
import classNames from 'classnames';
import { Checkbox } from '../../atoms/checkbox';
import DonateFormContextProvider, { DonateFormConfig } from './DonateFormContextProvider';
import { DonateFormContext } from './DonateFormContext';

interface DonateFormProps {
    config: DonateFormConfig;
}

const donateFormContainer = document.getElementsByTagName('donateformapp').item(1) as HTMLElement;
const donateFormFields = document.querySelectorAll('#donate-form-fields > div > div');

const DonateForm = ({ config }: DonateFormProps) => {
    const formFields = useMemo(() => parseFormFields(donateFormFields), []);

    return (
        <DonateFormContextProvider formFields={formFields} config={config}>
            <form className={classNames(styles['donate-form'], 'layout-grouping-children', 'layout-grouping-children--large')} onSubmit={(e) => e.preventDefault()}>
                <DonateFormFields fields={formFields} />
                <DonateFormContext.Consumer>
                    {({ formState, updateFormState }) => (
                        <Checkbox
                            id="tc-checkbox"
                            labelSlot={(
                                <span className={styles['donate-form__termsandconditions']}>
                                    I have read and understood these <a href="https://ww2.giveeasy.org/terms-and-conditions/">Terms and Conditions</a> in their entirety and agree to be bound by them
                                </span>
                            )}
                            onChange={(value) => updateFormState('terms', `${value}`)}
                            // this is actually a string
                            value={formState.terms === 'true'}
                        />
                    )}
                </DonateFormContext.Consumer>
                <DonateFormActions />
            </form>
        </DonateFormContextProvider>
    )
}

interface DonateFormAppProps {
    legacyurl: string;
    charitykey: string;
    haspaypalconnected: string;
    hasapplepaygooglepayenabled: string;
    stripepublishablekey: string;
}

const DonateFormApp = ({
    legacyurl,
    charitykey,
    hasapplepaygooglepayenabled,
    haspaypalconnected,
    stripepublishablekey
}: DonateFormAppProps) => {
    return ReactDOM.createPortal(<DonateForm config={{
        legacyUrl: legacyurl,
        charityKey: charitykey,
        isPayPalEnabled: haspaypalconnected === 'True',
        isAppleGooglePayEnabled: hasapplepaygooglepayenabled === 'True',
        stripePublishableKey: stripepublishablekey,
    }} />, donateFormContainer!.parentElement!);
}

export default DonateFormApp;
